/* DEFAULTS */
require('./vendor/parsley/parsley.js');
require('./vendor/parsley/init.js');
require('./vendor/parsley/i18n.1/nl.js');

// Sequence depending
require('alias_stub');

// Sequence indifferent
require('../library/legacy/forms/input-mask');
require('../library/legacy/forms/input-mask-binding');
require('../library/legacy/forms/outlined_form');
require('../library/legacy/forms/conditional_forms');
require('../library/legacy/forms/standardized_adres');
require('../library/forms/kenteken_element').initialize();
require('../library/legacy/forms/formsupload');
require('../library/legacy/forms/password_eye');
require('../library/legacy/forms/formulier-elements-additional-events');
require('../library/legacy/forms/lees-meer-tekens');
require('../library/legacy/forms/sendbutton');
require('../library/legacy/forms/clickoutform');


